export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '6',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Image',
    colSize: '4',
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'Name',
    colSize: '25',
    active: false,
    col: 'filename',
  }
];
